import { Swiper, SwiperSlide } from "swiper/react";

import {
  Pagination,
  Autoplay
} from "swiper/modules";

import "swiper/css";
import "swiper/css/pagination";

function Testimonials() {

  const reviews = [

    {
      name: "Rahul Sharma",

      text:
        "Amazing service and beautiful car. Highly recommended!",

      image:
        "https://randomuser.me/api/portraits/men/32.jpg"
    },

    {
      name: "Ankit Verma",

      text:
        "Best luxury car platform I’ve ever used.",

      image:
        "https://randomuser.me/api/portraits/men/45.jpg"
    },

    {
      name: "Priya Mehta",

      text:
        "Professional team and trustworthy experience.",

      image:
        "https://randomuser.me/api/portraits/women/65.jpg"
    },

    {
      name: "Sneha Reddy",

      text:
        "Smooth buying experience. Loved the support!",

      image:
        "https://randomuser.me/api/portraits/women/44.jpg"
    }

  ];

  return (

    <section className="testimonials">

      <h2>

        Testimonials

      </h2>

      <p className="subtitle">

        What our customers say about us

      </p>

      <Swiper

        modules={[Pagination, Autoplay]}

        slidesPerView={1}

        spaceBetween={30}

        pagination={{
          clickable: true
        }}

        autoplay={{
          delay: 3000
        }}

        breakpoints={{

          768: {
            slidesPerView: 2
          },

          1024: {
            slidesPerView: 3
          }

        }}

      >

        {reviews.map(
          (review, index) => (

            <SwiperSlide key={index}>

              <div className="review-card">

                <img
                  src={review.image}
                  alt={review.name}
                  className="review-img"
                />

                <p className="review-text">

                  "{review.text}"

                </p>

                <h4 className="review-name">

                  {review.name}

                </h4>

              </div>

            </SwiperSlide>

          )
        )}

      </Swiper>

    </section>

  );
}

export default Testimonials;